const AppRoutes = {
  homepage: '/',
  flights: '/flights',
  hotels: '/hotels',
  vacationpackages: '/vacationpackages'
} as const

export default AppRoutes
